angular
    .module('tradersyard')
    .config([
        'uiMask.ConfigProvider',
        function (uiMaskConfigProvider) {
            uiMaskConfigProvider.allowInvalidValue(false);
            uiMaskConfigProvider.clearOnBlur(false);
            uiMaskConfigProvider.maskDefinitions({ T: /(A|P)/, t: /(a|p)/ });
        },
    ])
    .factory('datetime-common', [
        function () {
            var is12 = /a/i.test(moment.localeData()._longDateFormat.LT);
            var is24 = !is12;

            var $format = {
                date: 'LL',
                time: is12 ? 'hh:mm A' : 'HH:mm',
            };

            var $default = {
                start: moment().add(1, 'h'),
                end: moment().add(2, 'h'),
            };

            var $factory = {
                is12: is12,
                is24: is24,
                format: $format,
                config: {
                    dateFormat: $format.date,
                    minDate: moment().subtract(1, 'days'),
                },
                gather: function (obj) {
                    date = moment(obj.date, $format.date);
                    time = obj.time ? obj.time.split(':') : is12 ? ['12', '00 AM'] : ['00', '00'];

                    if (is12 === true) {
                        var ampm = time[1].split(' ');

                        date.set({
                            hour: (ampm[1] === 'AM' ? 0 : 12) + (parseInt(time[0], 10) % 12),
                            minute: parseInt(ampm[0], 10),
                        });
                    } else {
                        date.set({
                            hour: parseInt(time[0], 10),
                            minute: parseInt(time[1], 10),
                        });
                    }

                    return date;
                },
                parse: function (obj, date, time) {
                    return {
                        date: obj.format(date ? date : $format.date),
                        time: obj.format(time ? time : $format.time),
                    };
                },
                rebuild: function (obj) {
                    return $factory.parse($factory.gather(obj));
                },
                default: $default,
                is: {
                    after: function (src, dest) {
                        $factory.diff(src, dest);
                    },
                    before: function (src, dest) {},
                },
                diff: function (src, dest) {
                    return dest.diff(src);
                },
                duration: function (src, dest) {
                    return moment.duration($factory.diff(src, dest));
                },
            };

            return $factory;
        },
    ])
    .controller('exhibition-create-ctrl', [
        '$scope',
        'graph-exhibition-factory',
        'datetime-common',
        '$flex',
        'graph-api-client',
        '$rootScope',
        function ($scope, exhibitionFactory, $common, $flex, $client, $root) {
            $scope.$error = {};
            $scope.buffer = {};
            $scope.$datetime = $common;
            // $scope.duration     = 0;
            $scope.diffed = 0;
            $scope.diffedExhibition = 0;
            $scope.queue = 0;
            $scope.inviteModel = [];
            $scope.groups = [];
            $scope.selectSettings = { styleActive: true, displayProp: 'name', showUncheckAll: false };
            $scope.groupPage = 1;

            $scope.colorPickerOptions = {
                format: ['rgb', 'hex', 'hexString', 'hex8', 'hex8String', 'raw'],
            };

            this.init = function () {
                $scope.getGroups();
            };

            $scope.boothUrl = [];
            $scope.optionalEquipmentUrl = '';
            $scope.eventTypeUrl = '';
            $scope.boothError = [];

            $scope.booths = [];
            $scope.optionalEquipments = [];
            $scope.speakerHalls = [];
            $scope.eventTypes = [];

            $scope.addBooth = function (url, key) {
                $scope.boothError[key] = undefined;
                $scope.boothUrl[key] = '';

                exhibitionFactory.addProduct(url, 'booth').then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.booths || [])
                                .map(function (booth) {
                                    if (booth && booth.id) {
                                        return booth.id;
                                    } else {
                                        return 0;
                                    }
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                $scope.booths[key] = response.data.data;
                            }
                        } else {
                            $scope.boothError[key] = response.data.data.url;
                            $scope.boothUrl[key] = url;
                        }
                    },
                    function (error) {
                        $scope.boothError[key] = 'An error occurred';
                        $scope.boothUrl[key] = url;
                    }
                );
            };

            $scope.addOptionalEquipment = function () {
                var url = $scope.optionalEquipmentUrl;
                $scope.optionalEquipmentError = undefined;
                $scope.optionalEquipmentUrl = '';

                exhibitionFactory.addProduct(url, 'optional-equipment').then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.optionalEquipments || [])
                                .map(function (booth) {
                                    return booth.id;
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                $scope.optionalEquipments = ($scope.optionalEquipments || []).concat([
                                    response.data.data,
                                ]);
                            }
                        } else {
                            $scope.optionalEquipmentError = response.data.data.url;
                            $scope.optionalEquipmentUrl = url;
                        }
                    },
                    function (error) {
                        $scope.optionalEquipmentError = 'An error occurred';
                        $scope.optionalEquipmentUrl = url;
                    }
                );
            };

            $scope.addEventType = function () {
                var url = $scope.eventTypeUrl;
                $scope.eventTypeError = undefined;
                $scope.eventTypeUrl = '';

                exhibitionFactory.addProduct(url, 'event-type').then(
                    function (response) {
                        if (response.data.state === 0) {
                            var index = ($scope.eventTypes || [])
                                .map(function (booth) {
                                    return booth.id;
                                })
                                .indexOf(response.data.data.id);

                            if (index < 0) {
                                response.data.data.time = 30;
                                $scope.eventTypes = ($scope.eventTypes || []).concat([response.data.data]);
                            }
                        } else {
                            $scope.eventTypeError = response.data.data.url;
                            $scope.eventTypeUrl = url;
                        }
                    },
                    function (error) {
                        $scope.eventTypeError = 'An error occurred';
                        $scope.eventTypeUrl = url;
                    }
                );
            };

            $scope.removeBooth = function (index) {
                $scope.boothUrl[index] = $scope.booths[index].url;
                $scope.booths[index] = undefined;
            };

            $scope.removeOptionalEquipment = function (index) {
                $scope.optionalEquipments.splice(index, 1);
            };

            $scope.removeEventType = function (index) {
                $scope.eventTypes.splice(index, 1);
            };

            $scope.getRandomColor = function () {
                var letters = '0123456789ABCDEF';
                var color = '#';

                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }

                return color;
            };

            $scope.addSpeakerHall = function () {
                if ($scope.speakerHalls.length < 6) {
                    $scope.speakerHalls.push({
                        name: `Speaker Hall ${$scope.speakerHalls.length + 1}`,
                        header_color: $scope.getRandomColor(),
                        background_color: $scope.getRandomColor(),
                    });
                }
            };

            $scope.removeSpeakerHall = function (index) {
                $scope.speakerHalls.splice(index, 1);
            };

            $scope.getGroups = function () {
                $client.get('me/groups?filter=my&limit=25&page=' + $scope.groupPage).then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.groups = $scope.parseGroups($response.data.data);
                        $scope.presetGroup();
                    }
                });
            };

            $scope.parseGroups = function (response) {
                var groups = [];
                response.forEach(function (group) {
                    groups.push(group);
                });
                return groups;
            };

            $scope.presetGroup = function () {
                var param = new URLSearchParams(window.location.search.slice(1));
                var groupId = param.get('group');

                if (groupId) {
                    $scope.groups.forEach(function (group) {
                        if (group.id == groupId) {
                            $scope.inviteModel = [group];
                            $scope.node.privacy = group.privacy;
                            $scope.privacyDisabled = true;
                        }
                    });
                }
            };

            $scope.calculate = function (moved) {
                $scope.node.exhibition_started_at.time = $scope.node.started_at.time;
                $scope.node.exhibition_ended_at.time = $scope.node.ended_at.time;

                var started_at = $common.gather($scope.node.started_at),
                    ended_at = $common.gather($scope.node.ended_at);

                var exhibition_started_at = $common.gather($scope.node.exhibition_started_at),
                    exhibition_ended_at = $common.gather($scope.node.exhibition_ended_at);

                if (moved === true) {
                    ended_at = started_at.clone().add($scope.diffed, 's');
                    exhibition_ended_at = exhibition_started_at.clone().add($scope.diffedExhibition, 's');
                }

                $scope.node.started_at = $common.parse(started_at);
                $scope.node.ended_at = $common.parse(ended_at);

                $scope.node.exhibition_started_at = $common.parse(exhibition_started_at);
                $scope.node.exhibition_ended_at = $common.parse(exhibition_ended_at);

                if ($scope.form.started_at_time) {
                    $scope.form.started_at_time.$setValidity('future', $common.diff(moment(), started_at) > 0);
                }

                $scope.form.languages.$setValidity('languages', Object.values($scope.languages).indexOf(true) != -1);

                $scope.diffed = $common.diff(started_at, ended_at) / 1000;
                $scope.diffedExhibition = $common.diff(exhibition_started_at, exhibition_ended_at) / 1000;

                if ($scope.form.ended_at_time) {
                    $scope.form.ended_at_time.$setValidity('future', $scope.diffed > 0);
                }
            };

            $scope.validate = function (data) {
                $scope.calculate();
                data.exhibition_started_at.time = data.started_at.time;
                data.exhibition_ended_at.time = data.ended_at.time;

                var started_at, ended_at, exhibition_started_at, exhibition_ended_at;

                started_at = $common.gather(data.started_at);
                ended_at = $common.gather(data.ended_at);
                exhibition_started_at = $common.gather(data.exhibition_started_at);
                exhibition_ended_at = $common.gather(data.exhibition_ended_at);

                var diff = $common.diff(started_at, ended_at);
                var diffExhibition = $common.diff(exhibition_started_at, exhibition_ended_at);

                if (diff > 0 && diffExhibition > 0) {
                    $scope.buffer = {
                        name: data.name,
                        description: data.description,
                        privacy: 'public',
                        booths_class_1: data.booths_class_1,
                        booths_class_2: data.booths_class_2,
                        booths_class_3: data.booths_class_3,
                        streams_class_1: data.streams_class_1,
                        streams_class_2: data.streams_class_2,
                        streams_class_3: data.streams_class_3,
                        booths_class_1_link_id: $scope.booths[1] ? $scope.booths[1].id : 0,
                        booths_class_2_link_id: $scope.booths[2] ? $scope.booths[2].id : 0,
                        booths_class_3_link_id: $scope.booths[3] ? $scope.booths[3].id : 0,
                        started_at: started_at.toISOString(),
                        ended_at: ended_at.toISOString(),
                        exhibition_started_at: exhibition_started_at.toISOString(),
                        exhibition_ended_at: exhibition_ended_at.toISOString(),
                        languages: data.languages,
                        floorplan_template: data.floorplan_template,
                        speaker_halls: $scope.speakerHalls,
                        booths: $scope.booths,
                        optionalEquipments: $scope.optionalEquipments,
                        eventTypes: $scope.eventTypes,
                    };

                    return true;
                } else {
                    return false;
                }
            };

            $scope.submit = function () {
                if ($scope.validate($scope.node) === true && $scope.queue === 0) {
                    $scope.queue = 1;
                    $scope.create($scope.buffer);
                }
            };

            $scope.create = function (data) {
                exhibitionFactory.create(data).then(function (response) {
                    if (response.data.state === 0) {
                        // exhibitionFactory.getMyProfile().then(function(profile) {
                        //    if (profile.data.data.google_sync) {
                        //        exhibitionFactory.googleCalendarSync(response.data.data);
                        //    }
                        // });

                        var inviteData = {
                            entry: 'exhibition',
                            entryId: response.data.data.id,
                            groups: $scope.inviteModel,
                        };
                        $root.$broadcast('invite-form-open');
                        $root.$broadcast('invite:custom', inviteData);
                        $scope.$on('invite-form-close', function () {
                            window.location.replace('/exhibition/' + response.data.data.id);
                        });
                    } else {
                        $scope.errors = response.data.data;
                        $scope.queue = 0;
                    }
                });
            };

            $scope.massInvite = function (exhibitionId) {
                return new Promise(function (resolve) {
                    if (!$scope.inviteModel) {
                        resolve();
                    }

                    var promises = [];

                    $scope.inviteModel.forEach(function (group) {
                        promises.push(
                            $client.post(['exhibition', exhibitionId, 'mass.invite', 'using.group.' + group.id])
                        );
                    });

                    Promise.all(promises).then(function ($response) {
                        resolve();
                    });
                });
            };

            $scope.languages = {
                en: true,
                de: false,
                ru: false,
            };

            $scope.langcheck = function (code) {
                var index = $scope.node.languages.indexOf(code);

                if (index === -1) {
                    $scope.node.languages.push(code);
                } else {
                    $scope.node.languages.splice(index, 1);
                }
            };

            $scope.node = {
                name: '',
                description: '',
                started_at: $common.parse($common.default.start),
                ended_at: $common.parse($common.default.end),
                exhibition_started_at: $common.parse($common.default.start),
                exhibition_ended_at: $common.parse($common.default.end),
                languages: ['en'],
                floorplan_template: '1',
                booths_class_1: 6,
                booths_class_2: 12,
                booths_class_3: 16,
                streams_class_1: 6,
                streams_class_2: 3,
                streams_class_3: 6,
                booths_class_1_link_id: 0,
                booths_class_2_link_id: 0,
                booths_class_3_link_id: 0,
            };

            if (angular.isObject($flex.data.node)) {
                angular.extend($scope.node, $flex.data.node);

                if (angular.isArray($flex.data.node.languages) && $flex.data.node.languages.length > 0) {
                    var languages = [];

                    $scope.node.languages.forEach(function (code) {
                        languages.push(code.code);
                        $scope.languages[code.code] = true;
                    });

                    $scope.node.languages = languages;
                } else {
                    $flex.data.node.languages = ['en'];
                }
            }

            $scope.is12 = $common.is12;
            $scope.is24 = $common.is24;

            setTimeout($scope.calculate, 0);

            this.init();
        },
    ]);
